import { news } from '../services/ApiService';
import { newsConstants } from '../constants/news';
import { offersConstants } from '../constants/offers';

export const setNews = (news = {}) => ({
  type: newsConstants.SET_NEWS_SUCCESS,
  news,
});

export const startSetNews = newsId => dispatch => {
  return news
    .getNews(newsId)
    .then((data = { items: [] }) => dispatch(setNews(data.items[0])))
    .catch(err => dispatch({ type: newsConstants.SET_NEWS_FAILURE }));
};

export const setNewsList = (news = [], total = 0) => ({
  type: newsConstants.SET_NEWS_LIST_SUCCESS,
  news,
  total,
});

export const startSetNewsList = params => dispatch => {
  return news
    .getList(params)
    .then((data = {}) => dispatch(setNewsList(data.items, data.total)))
    .catch(err => dispatch({ type: newsConstants.SET_NEWS_LIST_FAILURE }));
};

export const setWebmasterNewsList = (news = [], total = 0) => ({
  type: newsConstants.SET_MY_NEWS_LIST_SUCCESS,
  news,
  total,
});

export const startSetWebmasterNewsList = params => dispatch => {
  return news
    .getMyNews(params)
    .then((data = {}) => dispatch(setWebmasterNewsList(data.items, data.total)))
    .catch(err => dispatch({ type: newsConstants.SET_MY_NEWS_LIST_FAILURE }));
};

export const startSetNewOffersNewsList = params => dispatch => {
  return news
    .getNewOffersNews(params)
    .then((data = {}) => dispatch(setNewOffersNewsList(data.items, data.total)))
    .catch(err => dispatch({ type: newsConstants.SET_NEW_OFFERS_NEWS_FAILURE }));
};

export const setNewOffersNewsList = (news = [], total = 0) => ({
  type: newsConstants.SET_NEW_OFFERS_NEWS_SUCCESS,
  news,
  total,
});

export const setPromo = promotions => ({
  type: newsConstants.SET_NEWS_PROMO_SUCCESS,
  promotions,
});

export const resetPromo = () => ({type: newsConstants.RESET_NEWS_PROMO})

export const startSetPromo = params => dispatch => {
  return news
    .getPromo(params)
    .then((data = {}) => dispatch(setPromo(data.items)))
    .catch(err => ({ type: offersConstants.SET_NEWS_PROMO_FAILURE }));
};

export const setWebmasterPromo = promotions => ({
  type: newsConstants.SET_MY_NEWS_PROMO_SUCCESS,
  promotions,
});

export const resetWebmasterPromo = () => ({type: newsConstants.RESET_NEWS_PROMO})

export const startSetWebmasterPromo = params => dispatch => {
  return news
    .getMyPromo(params)
    .then((data = {}) => dispatch(setWebmasterPromo(data.items)))
    .catch(err => ({ type: offersConstants.SET_MY_NEWS_PROMO_FAILURE }));
};
